"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReactiveEnvelope = exports.ReactiveCashflow = void 0;
const variables_1 = require("./src/components/variables");
const cashflow_1 = require("./src/components/cashflow");
const optimus_1 = __importDefault(require("./src/optimus/optimus"));
const feature_flags_1 = require("./src/feature-flags");
exports.default = {
    setFeatureFlags: featureFlags => feature_flags_1.setFeatureFlags(featureFlags),
    createCashflow: (budget, dateLocale, filter) => new cashflow_1.ReactiveCashflow(budget, dateLocale, filter),
    variables: {
        create: (budget, dateLocale) => new variables_1.Variables(budget, dateLocale),
    },
    optimus: optimus_1.default,
};
__exportStar(require("./src/consts"), exports);
__exportStar(require("./src/types/base-types"), exports);
var cashflow_2 = require("./src/components/cashflow");
Object.defineProperty(exports, "ReactiveCashflow", { enumerable: true, get: function () { return cashflow_2.ReactiveCashflow; } });
var envelope_1 = require("./src/components/envelope");
Object.defineProperty(exports, "ReactiveEnvelope", { enumerable: true, get: function () { return envelope_1.ReactiveEnvelope; } });
//# sourceMappingURL=index.js.map